import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "premium-phones" }
const _hoisted_2 = { class: "premium-phones-header" }
const _hoisted_3 = { class: "premium-phones-header__title" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = { class: "premium-phones-mobile_header" }
const _hoisted_6 = { class: "h1" }
const _hoisted_7 = { class: "premium-phones--body" }
const _hoisted_8 = { class: "premium-phones--body-title" }
const _hoisted_9 = { class: "h1" }
const _hoisted_10 = { class: "premium-phones--body-search" }
const _hoisted_11 = { class: "premium-phones--body-tabs" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "premium-phones--body-main" }
const _hoisted_14 = {
  key: 0,
  class: "premium-phones--body-loader"
}
const _hoisted_15 = { class: "premium-phones--body-loader-pic" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "premium-phones--body-category_empty"
}
const _hoisted_18 = { class: "caption-medium" }

import BaseInput from "@/components/base/BaseInput.vue";
import PremiumNumbersCategory from "@/components/premium/PremiumNumbersCategory.vue";
import PremiumPhonesModals from "@/components/premium/PremiumPhonesModals.vue";
import { usePremiumPhones } from "@/composables/premium/usePremiumPhones";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PremiumPhonesPage',
  setup(__props) {

const {
  activeTab,
  activeNumber,
  activeNumberPrice,
  activeNumberType,
  changeNumberToPremium,
  closeSuccessModal,
  errorModal,
  errorSixMonthsModal,
  formatPhone,
  isLoadingChangeNumber,
  openModal,
  openModalFirstPayment,
  openModalLowMoney,
  openModalSecondPayment,
  openModalTwoParts,
  searchValue,
  selectNumber,
  successModal,
  t,
  tabs,
  tabsClasses,
  toPayment,
  walletAmount,
  walletAmountCalc,

  isLoadingListing,
  clickTab,
  loadMore,
  visibleCategories,
  isAllCategoriesEmpty,
  premiumNumbersMap,
  configDataBrand,
} = usePremiumPhones();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "account",
        class: "premium-phones-header__back"
      }, {
        default: _withCtx(() => [
          _createVNode(BaseFigureForIcon, {
            size: "medium",
            color: "white",
            icon: "arrow",
            position: "left",
            "is-button": ""
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("premium.title")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("premium.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("premium.selectNumber")), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(BaseInput, {
          modelValue: _unref(searchValue),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchValue) ? (searchValue).value = $event : null)),
          type: "digit",
          "max-length": 11,
          placeholder: _unref(t)('premium.searchPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["premium-phones--body-tab caption-navbar", _unref(tabsClasses)(item.name)]),
            onClick: ($event: any) => (_unref(clickTab)(item))
          }, _toDisplayString(item.title), 11, _hoisted_12))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_unref(isLoadingListing))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      src: _unref(configDataBrand).assets.loader,
                      alt: "Загрузка"
                    }, null, 8, _hoisted_16)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "tab",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: _unref(activeTab).name,
              class: "premium-phones--body-list"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleCategories), (category) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: category.id
                }, [
                  (
                  !(
                    _unref(activeTab).name === 'all' &&
                    !_unref(premiumNumbersMap).get(category?.name)?.numbers?.length
                  )
                )
                    ? (_openBlock(), _createBlock(PremiumNumbersCategory, {
                        key: 0,
                        isLoadingListing: _unref(isLoadingListing),
                        searchValue: _unref(searchValue),
                        "active-number": _unref(activeNumber),
                        "format-phone": _unref(formatPhone),
                        numbers: _unref(premiumNumbersMap).get(category?.name)?.numbers,
                        isFilled: _unref(premiumNumbersMap).get(category?.name)?.isFilled,
                        title: category.displayName,
                        onSelect: _unref(selectNumber),
                        onShowMore: ($event: any) => (_unref(loadMore)(category.name))
                      }, null, 8, ["isLoadingListing", "searchValue", "active-number", "format-phone", "numbers", "isFilled", "title", "onSelect", "onShowMore"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (
                _unref(isAllCategoriesEmpty) &&
                _unref(activeTab).name === 'all' &&
                !_unref(isLoadingListing)
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("premium.notFound")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(PremiumPhonesModals, {
      "active-number": _unref(activeNumber),
      "active-number-price": _unref(activeNumberPrice),
      "active-number-type": _unref(activeNumberType),
      "error-modal": _unref(errorModal),
      "error-six-months-modal": _unref(errorSixMonthsModal),
      "format-phone": _unref(formatPhone),
      "is-loading-change-number": _unref(isLoadingChangeNumber),
      "open-modal": _unref(openModal),
      "open-modal-first-payment": _unref(openModalFirstPayment),
      "open-modal-low-money": _unref(openModalLowMoney),
      "open-modal-second-payment": _unref(openModalSecondPayment),
      "open-modal-two-parts": _unref(openModalTwoParts),
      "success-modal": _unref(successModal),
      "wallet-amount": _unref(walletAmount),
      "wallet-amount-calc": _unref(walletAmountCalc),
      onCloseConfirm: _cache[1] || (_cache[1] = ($event: any) => (openModal.value = false)),
      onCloseError: _cache[2] || (_cache[2] = ($event: any) => (errorModal.value = false)),
      onCloseFirstPayment: _cache[3] || (_cache[3] = ($event: any) => (openModalFirstPayment.value = false)),
      onCloseLowMoney: _cache[4] || (_cache[4] = ($event: any) => (openModalLowMoney.value = false)),
      onCloseSecondPayment: _cache[5] || (_cache[5] = ($event: any) => (openModalSecondPayment.value = false)),
      onCloseSixMonthsError: _cache[6] || (_cache[6] = ($event: any) => (errorSixMonthsModal.value = false)),
      onCloseSuccess: _unref(closeSuccessModal),
      onCloseTwoParts: _cache[7] || (_cache[7] = ($event: any) => (openModalTwoParts.value = false)),
      onConfirm: _unref(changeNumberToPremium),
      onContinueToFirstPayment: _cache[8] || (_cache[8] = ($event: any) => {
        openModalTwoParts.value = false;
        openModalFirstPayment.value = true;
      }),
      onContinueToSecondPayment: _cache[9] || (_cache[9] = ($event: any) => {
        _unref(toPayment)();
        openModalFirstPayment.value = false;
        openModalSecondPayment.value = true;
      }),
      onToPayment: _unref(toPayment)
    }, null, 8, ["active-number", "active-number-price", "active-number-type", "error-modal", "error-six-months-modal", "format-phone", "is-loading-change-number", "open-modal", "open-modal-first-payment", "open-modal-low-money", "open-modal-second-payment", "open-modal-two-parts", "success-modal", "wallet-amount", "wallet-amount-calc", "onCloseSuccess", "onConfirm", "onToPayment"])
  ]))
}
}

})